import { StockAllocationError } from '../errors';

export const isStockAllocationError = (error: unknown): error is StockAllocationError => {
    return error instanceof StockAllocationError;
};
